<template>
    <div class="indexCont">
        <div class="mainCont"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading">
            <div class="examItem" v-for="(item,index) in itemList" :key="index">
                <template v-if="item">
                    <div class="eTitle">{{index + 1}}、{{item.name}} 【{{item.typeName}}】</div>
                    <!-- 选择和判断需要循环选项，填空无需 -->
                    <template v-if="item.type == 1 || item.type ==2">
                        <div class="comItem" v-for="(item2,index2) in item.content" :key="index2">
                            <div v-show="item2.detail || item2.url ? true : false">{{item2.name}}、 {{item2.detail}}</div>
                            <!-- 有url -->
                            <template v-if="item2.url">
                                <img class="comItem_img" :src="$config.baseApi + item2.url" alt="">
                            </template>
                        </div>
                    </template>
                    <!-- <template v-else></template> -->
                    <div class="Answer">
                        <div class="comBtn2">
                            回答错误，答案是：<span>{{item.answer}}</span>
                        </div>
                    </div>
                    <div class="analysis">
                        解析：<span>{{item.answerAnalysis ? item.answerAnalysis : "暂无解析"}}</span>
                    </div>
                    <div class="comBtn" @click="removeItem(item.id)">移除错题</div>
                </template>
            </div>
             <div class="page" v-show="!isShow">
                <el-pagination
                background
                layout="prev, pager, next"
                :total="paperInfo.total"
                :page-size="this.pageSize"
                @current-change="changePage"
                ></el-pagination>
            </div>
            <!-- 没有数据时 -->
            <div class="comTxt" v-show="isShow">暂无数据</div>
        </div>
         <!-- 移动端显示 -->
        <div class="mobileTest">
           <MobileComNav title="错题集"></MobileComNav>
        </div>
        <!-- 弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            :width="dialogWidth"
            center>
            <span>是否确定移除错题</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="delMistakesItem()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import MobileComNav from "../../../components/mobileHead";
    export default {
        inject:['reload'],
        data(){
            return {
                centerDialogVisible: false,
                dialogWidth: "30%",
                paperInfo:"",
                itemList:"",
                loading:true,
                current:1,
                pageSize:10,
                questionId:"",
                isShow:false
            }
        },
        components: {
            MobileComNav
        },
        mounted(){
            document.title=this.$route.meta.title
        },
        methods: {
            mistakeList(){
                let url = this.$config.baseApi + "/examination/mistake/list";
                this.$ajax({
                    url: url,
                    method: "post",
                    data:JSON.stringify({
                        searchName:"", //资源名
                        current:this.current,//	当前页
                        pageSize:this.pageSize, //每页个数
                    })
                }).then(res => {
                    if (res.code == 1) {
                        this.paperInfo = res.data;
                        let itemList = res.data.records;
                        if(res.data.total == 0){
                            this.isShow = true
                        }
                        this.itemList = itemList
                        this.loading = false
                    }else{
                        this.$message({
                            message:res.msg,
                            type:"error"
                        })
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            removeItem(questionId){
                this.centerDialogVisible = true
                this.questionId = questionId
            },
            // 移除错题
            delMistakesItem(){
                this.centerDialogVisible = false;
                let url = this.$config.baseApi + "/examination/mistake/del";
                this.$ajax({
                    url: url,
                    method: "post",
                    data:JSON.stringify({
                        questionId:this.questionId 
                    })
                }).then(res => {
                    console.log(res)
                    if (res.code == 1) {
                        this.$message({
                            message:res.msg,
                            type:"success"
                        });
                        setTimeout(()=>{
                            this.reload()
                        },800)
                    }else{
                        this.$message({
                            message:res.msg,
                            type:"error"
                        })
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 分页改变
            changePage(pageIndex) {
                this.current = pageIndex;
                this.mistakeList();
            }
        },
        created(){
            if(this.$IsPc()){
                // 移动改变弹窗宽度；
                this.dialogWidth = "80%";
                this.pageSize = 10000;
            };
            this.mistakeList()
        }
    }
</script>

<style scoped>
    .mainCont{
        background: #fff;
        padding:0.17rem 0.3rem;
        position: relative;
        min-height: 4rem;
    }
    .mobileTest{
        display: none;
        margin-top: 1.2rem;
    }
    .examItem{
        margin-bottom: 0.2rem
    }
    /* 题目样式 */
    .mainCont .examItem .el-radio,.mainCont .examItem .el-checkbox{
        display: block;
        margin:0.1rem 0;
    }
    .comBtn{
        margin:0.1rem 0;
    }
    .Answer .comBtn2{
        display: inline-block;
        background:rgba(250, 85, 36, 1);
        padding:0.09rem 0.2rem;
        font-size: 0.12rem;
        border-radius: 4px;
        color: #fff;
        line-height: 0.14rem;
        margin-bottom: 0.1rem
    }
    .page {
        text-align: center;
    }
    @media screen and (max-width: 768px) {
        .mainCont {
            margin-top:0.9rem;
            box-sizing: border-box;
            background:transparent;
            padding:0;
            min-height: 8rem;
        }
        .examItem{
            box-sizing: border-box;
            background: #fff;
            width:90%;
            margin:0 auto;
            padding:0.2rem;
            margin-bottom: 0.4rem;
            font-size: 0.32rem;
        }
        .page{
            display: none;
        }
        .mainCont .examItem .el-radio,.mainCont .examItem .el-checkbox{
            margin:0.2rem 0;
        }
        .mobileTest {
            display: block;
        }  
        .Answer .comBtn2{
            padding:0.18rem 0.4rem;
            font-size: 0.28rem;
            line-height: 0.28rem;
            margin-bottom: 0.2rem
        }
        .comBtn{
            margin:0.2rem 0;
            /* background-color: rgba(250, 85, 36, 1); */
        }
    }
</style>

